import {
  Component,
  EventEmitter,
  Inject,
  Injector,
  Input,
  Output,
} from "@angular/core";
import { DateAdapter, MAT_DATE_LOCALE } from "@angular/material/core";
import { appModuleAnimation } from "@shared/animations/routerTransition";
import { AppComponentBase } from "@shared/app-component-base";
import { JalaliDateAdapter } from "@shared/helpers/jalali-date-adapter";
import * as moment from "jalali-moment";

const jm = (moment as any).default ?? moment;

@Component({
  selector: "app-date-picker",
  templateUrl: "./date-picker.component.html",
  styleUrls: ["./date-picker.component.css"],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: "fa-IR" },
    { provide: DateAdapter, useClass: JalaliDateAdapter },
  ],
  animations: [appModuleAnimation()],
})
export class DatePickerComponent extends AppComponentBase {
  @Input() ShowTime: boolean = false;
  @Input() minDate: string | null = null;
  @Input() maxDate: string | null = null;
  @Input() Date: Date = new Date();
  @Input() placeholder: string = "ChooseADate";


  time: string|null = "--:--";

  @Output() SelectedDateChange = new EventEmitter<Date>();

  selectedDate: any;

  config = {
    format: "jYYYY/jMM/jDD",
    timePicker: false,
    closeOnSelect: true,
  };

  changeDate(date: any) {
    this.Date = date._d;
    if (this.ShowTime) {
      this.Date.setHours(
        parseInt(this.time?.substr(0, 2) ?? "00"),
        parseInt(this.time?.substr(3, 2) ?? "00"),
      );
    }
    this.SelectedDateChange.emit(this.Date);
  }

  timeChanged() {
    if (this.ShowTime) {
      this.Date.setHours(
        parseInt(this.time?.substr(0, 2) ?? "00"),
        parseInt(this.time?.substr(3, 2) ?? "00"),
      );
    }
    this.SelectedDateChange.emit(this.Date);
  }

  constructor(
    injector: Injector,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
  ) {
    super(injector);

    setTimeout(() => {
      if (this.Date != null) {
        this.time =
          this.Date.getHours().toString().padStart(2, "0") +
          ":" +
          this.Date.getMinutes().toString().padStart(2, "0");
      }
      else {
        this.time = null;
      }
    }, 200);

    this._locale = abp.localization.currentLanguage.name;

    if (this._locale == "fa") {
      (this._adapter as any).setJalaliMode(true);
    } else {
      (this._adapter as any).setJalaliMode(false);
    }

    //this._adapter.setLocale(this._locale);
  }
}
